var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAboutLine1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 309,
    height: 149,
    viewBox: "0 0 309 149",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 117C38.2652 115.643 66.1327 120.841 103.774 112.516C130.17 106.679 156.186 98.2099 181.386 88.4724C210.724 77.1358 240.016 64.222 266.279 46.7461C292.542 29.2702 307.5 1.5 307.5 1.5",
    stroke: "#C9C1AE",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 147C56.3607 103.479 133.3 48.5307 198.153 19.5541C214.62 12.1964 234.1 4.3004 252.503 2",
    stroke: "#650D1B",
    strokeWidth: 3,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAboutLine1);
export default __webpack_public_path__ + "static/media/aboutLine1.5976e611b8b5b19474c973c2aa0a3fd3.svg";
export { ForwardRef as ReactComponent };